import React from "react";
import PaymentsTable from "../../../components/patient-side-components/payments-table/PaymentsTable";

const PatientPaymentHistory = () => {
  return (
    <div className="flex w-full items-center justify-center flex-col relative">
      <PaymentsTable />
    </div>
  );
};

export default PatientPaymentHistory;
